var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('log-in',{staticClass:"couples-log-in"},[_c('img',{attrs:{"src":require("@/assets/lasting_couples_heart_icon.svg"),"alt":"Lasting for Couples Icon","width":"65","height":"65"}})])}
var staticRenderFns = []

export { render, staticRenderFns }